module.exports = __webpack_public_path__ + "static/jet-0f157948db8a1409e97917bc2c778953.jpg";